import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */

function LocationIcon(props) {
  return (
    <SvgIcon viewBox="0 0 27 34" title="View Locations" {...props}>
      <path
        d="M13.3333 17C14.25 17 15.0347 16.6737 15.6875 16.0209C16.3403 15.3681 16.6667 14.5834 16.6667 13.6667C16.6667 12.75 16.3403 11.9653 15.6875 11.3125C15.0347 10.6598 14.25 10.3334 13.3333 10.3334C12.4167 10.3334 11.6319 10.6598 10.9792 11.3125C10.3264 11.9653 10 12.75 10 13.6667C10 14.5834 10.3264 15.3681 10.9792 16.0209C11.6319 16.6737 12.4167 17 13.3333 17ZM13.3333 29.25C16.7222 26.1389 19.2361 23.3125 20.875 20.7709C22.5139 18.2292 23.3333 15.9723 23.3333 14C23.3333 10.9723 22.3681 8.4931 20.4375 6.56254C18.5069 4.63199 16.1389 3.66671 13.3333 3.66671C10.5278 3.66671 8.15972 4.63199 6.22917 6.56254C4.29861 8.4931 3.33333 10.9723 3.33333 14C3.33333 15.9723 4.15278 18.2292 5.79167 20.7709C7.43056 23.3125 9.94444 26.1389 13.3333 29.25ZM13.3333 33.6667C8.86111 29.8612 5.52083 26.3264 3.3125 23.0625C1.10417 19.7987 0 16.7778 0 14C0 9.83337 1.34028 6.51393 4.02083 4.04171C6.70139 1.56949 9.80556 0.333374 13.3333 0.333374C16.8611 0.333374 19.9653 1.56949 22.6458 4.04171C25.3264 6.51393 26.6667 9.83337 26.6667 14C26.6667 16.7778 25.5625 19.7987 23.3542 23.0625C21.1458 26.3264 17.8056 29.8612 13.3333 33.6667Z"
        fill="white"
      />
    </SvgIcon>
  );
}

export default LocationIcon;
